import { createContext } from 'react'
import { HelpContextProps } from '@/presentation/common/store/apiContext/types.ts'

export const HelpContext = createContext<HelpContextProps>({
  content    : null,
  setContent : () => void 0,
  render     : () => void 0,
})
